<div class="modal-md">
  <div class="modal-body">
    <p tabindex="0">
      <strong><div [innerHtml]="mensagem"></div></strong>
    </p>
  </div>
  <div class="modal-footer justify-content-center">
    <button
      type="button"
      class="btn btn-primary"
      role="button"
      tabindex="0"
      (click)="confirmar()">
      <fa-icon [icon]="iconCofirmacao" class="fa-md pe-2"></fa-icon>
      {{ btConfirmacao }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      role="button"
      tabindex="0"
      *ngIf="btRecusa"
      (click)="fechar()">
      <fa-icon [icon]="iconRecusa" class="fa-md pe-2"></fa-icon>
      {{ btRecusa }}
    </button>
  </div>
</div>
